import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=45146411&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=45146411&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45146411",
  null
  
)

export default component.exports